import { GalleryImageVM } from '../../shared/gallery/gallery-image-vm';

export class FullscreenGalleryVM {
  constructor(public Images: Array<GalleryImageVM> = [], public SelectedIndex: number = 0) {}
}
